import { Plan } from '@/app/(intakeFormV2)/intake-v2/types';
import { Check } from 'lucide-react';
import { ReactNode, useState } from 'react';
import { PlanDetails } from '../PlanDetails';

import clsx from 'clsx';
import './DetailsCard.scss';

const Backgrounds: Record<Plan, string> = {
  Pediatrics: 'bg-sh-paper',
  Platinum: 'bg-sh-cream',
  Signature: 'bg-sh-teal',
};

const CheckedListItem = (props: {
  children: string | ReactNode;
  color: string;
}) => {
  const style = `my-auto shrink-0 rounded-full ${props.color} p-1`;

  return (
    <div className='flex gap-[16px]'>
      <div className={style}>
        <Check color='white' height='16px' width='16px' />
      </div>
      <div className='min-w-0 flex-1 wrap-break-word'>{props.children}</div>
    </div>
  );
};

export const DetailsCard = ({ plan }: { plan: Plan }) => {
  const [expanded, setExpanded] = useState(false);
  const details = PlanDetails[plan];
  const style = `${Backgrounds[plan]} sh-body p-8 rounded-2xl`;

  return (
    <div
      className={clsx(
        'DetailsCard',
        { 'DetailsCard--expanded': expanded },
        style
      )}
    >
      <div className='DetailsCard__header'>
        <p>
          <strong>{plan} Membership</strong>
        </p>

        {!expanded && (
          <p className='DetailsCard__trigger' onClick={() => setExpanded(true)}>
            See what’s included in your membership
          </p>
        )}
      </div>

      {expanded && (
        <>
          <ul className='text-[18px]'>
            {details.map((u, i) => (
              <li className='my-4' key={i}>
                <CheckedListItem color='bg-[#B0AEAC]'>{u}</CheckedListItem>
              </li>
            ))}
          </ul>

          {details.some(u => u.includes('*')) && (
            <>
              <div className='text-sm text-[18px]'>
                *When clinically indicated. Availability depending on location.
              </div>
              <div className='text-sm text-[18px]'>
                **CT scan is for members over 40. Availability depending on
                location.
              </div>
            </>
          )}

          <p
            className='DetailsCard__trigger DetailsCard__trigger--close'
            onClick={() => setExpanded(false)}
          >
            Show less
          </p>
        </>
      )}
    </div>
  );
};
